var React = require('react');

function CirclePound12 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM8 4C8 2.89543 7.10457 2 6 2C4.89543 2 4 2.89543 4 4C4 4.6529 4.32462 5.13898 4.56246 5.49512L4.58397 5.52735C4.70373 5.70699 4.80124 5.85777 4.87167 6H4V7H4.99477C4.98339 7.40836 4.94736 7.85209 4.83359 8.23133C4.75368 8.49768 4.64694 8.68983 4.52037 8.81172C4.40642 8.92144 4.25107 9 4 9V10H8V9H5.60114C5.68131 8.84309 5.7431 8.6797 5.79141 8.51867C5.94179 8.01743 5.98379 7.45695 5.99549 7H7V6H5.93531C5.82858 5.59041 5.61019 5.26341 5.43754 5.00488L5.41603 4.97265C5.15527 4.58152 5 4.32719 5 4C5 3.44772 5.44772 3 6 3C6.55229 3 7 3.44772 7 4H8Z","fill":"currentColor"}));
}

CirclePound12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = CirclePound12;

CirclePound12.default = CirclePound12;
